import { useState } from 'react';
import React, { useRef } from 'react';

import { UbexMediaLgDark } from '../../../assets/icons';
import { useNotif } from '../../../contexts/Notification';
import { userManagement as $content } from '../../../content';
import { useUser } from '../../../contexts/User';
import Input from '../../../components/Input';
// import { useResponsiveDevice } from '../../../contexts/ResponsiveDevice';
import Button from '../../../components/Button';
import { useNavigate } from 'react-router-dom';
import { requestEmailOTP, verifyEmailOTP } from '../../../services';
// import { useTheme } from '../../../contexts/Theme';
import InputLabel from '../../../components/Input/InputLabel';

const OTP_LENGTH = 8;

const SigninUser = () => {
  const navigate = useNavigate();
  // const { isDark } = useTheme();
  const { notifySuccess, notifyError } = useNotif();
  // const { isMobileView } = useResponsiveDevice();
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(false);
  const [isValidOtp, setIsValidOtp] = useState(false);
  const [currentStep, setCurrentStep] = useState('email');
  const [isLoading, setIsLoading] = useState(false);
  const [otpArray, setOtpArray] = useState(Array(OTP_LENGTH).fill(''));
  const otpInputsRef = useRef([]);
  const { checkSessionStatus } = useUser();
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValid = emailRegex.test(email);
    setIsValidEmail(isValid);
    if (!isValid) {
      setError(true);
      setErrorText('Please enter a valid email address');
    } else {
      setError(false);
      setErrorText('');
    }
  };
  const validateOtp = (otp) => {
    // Validate that OTP is exactly 8 digits
    const otpRegex = /^\d{8}$/;
    const isValid = otpRegex.test(otp);
    setIsValidOtp(isValid);
    if (!otp) {
      setError(true);
      setErrorText('Verification Code is required');
    } else if (!/^\d*$/.test(otp)) {
      setError(true);
      setErrorText('Verification Code must contain only numbers');
    } else if (otp.length !== 8) {
      setError(true);
      setErrorText('Verification Code must be exactly 8 digits');
    } else {
      setError(false);
      setErrorText('');
    }
    return isValid;
  };

  const handleOtpChange = (e, idx) => {
    const val = e.target.value.replace(/\D/g, '');
    if (!val) return;
    const newArr = [...otpArray];
    newArr[idx] = val[val.length - 1];
    setOtpArray(newArr);
    setOtp(newArr.join(''));
    validateOtp(newArr.join(''));
    if (val && idx < OTP_LENGTH - 1) {
      otpInputsRef.current[idx + 1]?.focus();
    }
  };

  const handleOtpKeyDown = (e, idx) => {
    if (e.key === 'Backspace') {
      if (otpArray[idx]) {
        const newArr = [...otpArray];
        newArr[idx] = '';
        setOtpArray(newArr);
        setOtp(newArr.join(''));
        validateOtp(newArr.join(''));
      } else if (idx > 0) {
        otpInputsRef.current[idx - 1]?.focus();
      }
    } else if (e.key === 'ArrowLeft' && idx > 0) {
      otpInputsRef.current[idx - 1]?.focus();
    } else if (e.key === 'ArrowRight' && idx < OTP_LENGTH - 1) {
      otpInputsRef.current[idx + 1]?.focus();
    }
  };

  const handleResendOtp = async () => {
    setIsLoading(true);
    try {
      const otpEmailSendResponse = await requestEmailOTP(email);
      if (!otpEmailSendResponse.data) {
        notifyError('Failed to send Verification Code. Please try again.');
        setIsLoading(false);
        setError(false);
        setErrorText('');
        return;
      }
      notifySuccess('Email sent successfully');
      setIsLoading(false);
      setCurrentStep('otp');
      setError(false);
      setErrorText('');
    } catch (error) {
      switch (error.name) {
        case 'UserNotFoundException':
          notifyError(
            'Email not registered. Please check your email or Contact the administration.'
          );
          break;
        case 'LimitExceededException':
          notifyError('Too many attempts. Please try again later.');
          break;
        case 'NotAuthorizedException':
          notifyError('Invalid credentials.');
          break;
        default:
          notifyError(
            error.message ||
              'Failed to send Verification Code. Please try again.'
          );
      }
      setIsLoading(false);
    }
  };

  // Add this handler function after the handleOtpKeyDown function
  const handlePaste = (e) => {
    try {
      e.preventDefault();
      const pastedData = e.clipboardData.getData('text').replace(/\D/g, '');
      if (!pastedData) return;

      // Take only the first OTP_LENGTH characters
      const pastedArray = pastedData.slice(0, OTP_LENGTH).split('');
      const newArray = Array(OTP_LENGTH).fill('');

      pastedArray.forEach((val, idx) => {
        newArray[idx] = val;
      });

      setOtpArray(newArray);
      setOtp(newArray.join(''));
      validateOtp(newArray.join(''));

      // Focus on the last filled input or the next empty input
      const lastFilledIndex = newArray.findLastIndex((val) => val !== '');
      const nextIndex = Math.min(lastFilledIndex + 1, OTP_LENGTH - 1);
      otpInputsRef.current[nextIndex]?.focus();
    } catch (error) {
      console.error('Error handling paste:', error);
      return;
    }
  };
  const handleButtonClick = async () => {
    if (currentStep === 'email') {
      setIsLoading(true);
      try {
        const otpEmailSendResponse = await requestEmailOTP(email);
        if (!otpEmailSendResponse) {
          notifyError('Failed to send Verification Code. Please try again.');
          setIsLoading(false);
          setError(false);
          setErrorText('');
          return;
        }
        notifySuccess('Email sent successfully');
        setIsLoading(false);
        setCurrentStep('otp');
        setError(false);
        setErrorText('');
      } catch (error) {
        switch (error.name) {
          case 'UserNotFoundException':
            notifyError(
              'Email not registered. Please check your email or Contact the administration.'
            );
            break;
          case 'LimitExceededException':
            notifyError('Too many attempts. Please try again later.');
            break;
          case 'NotAuthorizedException':
            notifyError('Invalid credentials.');
            break;
          default:
            notifyError(
              error.message ||
                'Failed to send Verification Code. Please try again.'
            );
        }
        setIsLoading(false);
      }
    }
    if (currentStep === 'otp') {
      setIsLoading(true);
      try {
        const sessionResponse = await verifyEmailOTP(otp);
        if (!sessionResponse.session) {
          notifyError('Failed to verify Verification Code. Please try again.');
          setError(false);
          setErrorText('');
          setIsLoading(false);
          return;
        }
        notifySuccess('Sign In successfully');
        setIsLoading(false);
        await checkSessionStatus();
        navigate('/');
        setCurrentStep('email');
        setError(false);
        setErrorText('');
      } catch (error) {
        switch (error.name) {
          case 'CodeMismatchException':
            notifyError(
              'Incorrect Verification Code. Please check and try again.'
            );
            break;
          case 'ExpiredCodeException':
            notifyError(
              'Verification Code has expired. Please request a new Verification Code.'
            );
            break;
          case 'LimitExceededException':
            notifyError('Too many attempts. Please try again later.');
            break;
          case 'NotAuthorizedException':
            notifyError(
              'Authentication failed. Please request a new Verification Code.'
            );
            break;
          case 'TooManyFailedAttemptsException':
            notifyError(
              'Account temporarily locked due to too many failed attempts. Please try again later.'
            );
            break;
          case 'TooManyRequestsException':
            notifyError(
              'Too many requests. Please wait a moment and try again.'
            );
            break;
          default:
            notifyError('Something went wrong. Please try again.');
            break;
        }
        setError(true);
        setErrorText('');
        setIsLoading(false);
      }
    }
  };
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-lightMode-bg dark:bg-darkMode-bg">
      <div className="rounded-3xl shadow-xl bg-white dark:bg-[#181A20] p-8 w-full max-w-md flex flex-col items-start">
        <div className="w-full h-12 mb-2 flex items-center justify-center">
          <UbexMediaLgDark className="w-48 h-full" />
        </div>
        <h1 className="mb-5 text-2xl font-semibold text-center dark:text-white text-black w-full items-center">
          {$content.login_page.title}
        </h1>
        <div className="w-full flex mb-5">
          <span className={'bg-gray-200 dark:bg-gray-700 h-[1px] w-full'} />
        </div>

        <div className="w-full flex flex-col gap-4">
          {currentStep === 'email' && (
            <Input
              label={'Email'}
              name="email"
              placeholder={$content.login_page.email_placeholder}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                validateEmail(e.target.value);
              }}
              onBlur={(e) => validateEmail(e.target.value)}
              error={error ? errorText : ''}
              className="rounded-lg "
            />
          )}
          {currentStep === 'otp' && (
            <>
              <InputLabel
                className="block text-sm font-medium mb-2 dark:text-white text-black"
                label="Enter Verification Code"
              />

              <div className="flex justify-between gap-2 mb-2">
                {otpArray.map((digit, idx) => (
                  <input
                    key={idx}
                    ref={(el) => (otpInputsRef.current[idx] = el)}
                    type="text"
                    inputMode="numeric"
                    maxLength={1}
                    className="w-10 h-12 rounded-lg border border-gray-300 dark:border-gray-700 bg-lightMode-bg dark:bg-[#23272F] text-center text-2xl font-mono focus:outline-none focus:ring-2 focus:ring-lightMode-blue dark:focus:ring-lightMode-blue text-black dark:text-white"
                    value={digit}
                    onChange={(e) => handleOtpChange(e, idx)}
                    onKeyDown={(e) => handleOtpKeyDown(e, idx)}
                    onPaste={(e) => handlePaste(e)}
                    disabled={isLoading}
                  />
                ))}
              </div>
              {error && errorText && (
                <div className="text-red-500 text-xs mb-2">{errorText}</div>
              )}
              <div className="mt-2 text-black dark:text-white text-center">
                Didn't receive the Code?{' '}
                <button
                  onClick={handleResendOtp}
                  className="text-lightMode-blue dark:text-lightMode-blue hover:underline text-sm"
                  disabled={isLoading}
                >
                  Resend Code
                </button>
              </div>
            </>
          )}
          <div className="flex flex-col gap-2 w-full mt-2">
            <Button
              onClick={handleButtonClick}
              isDisabled={
                isLoading ||
                (currentStep === 'email' && !isValidEmail) ||
                (currentStep === 'otp' && !isValidOtp)
              }
              isLoading={isLoading}
              className="dark:bg-darkMode-blue text-white dark:hover:bg-darkMode-blue-hover rounded-lg"
            >
              {currentStep === 'email'
                ? $content.login_page.send_OTP
                : $content.sign_in}
            </Button>
            {currentStep === 'otp' && (
              <Button
                onClick={() => {
                  setCurrentStep('email');
                  setError(false);
                  setErrorText('');
                  setOtpArray(Array(OTP_LENGTH).fill(''));
                  setOtp('');
                }}
                isDisabled={isLoading}
                variant="outlined"
                className="rounded-lg text-gray-700 dark:text-white  hover:bg-darkMode-blue hover:text-white"
              >
                Back
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SigninUser;
